<template>
  <div>
    <ag-grid-vue
      class="ag-theme-balham ag-grid-table-pagos-detalles-solicitudes"
      colResizeDefault="shift"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      :rowClassRules="rowClassRules"
      :suppressRowClickSelection="true"
      :animateRows="true"
      :floatingFilter="false"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :pinnedBottomRowData="pinnedBottomRowData"
      @grid-ready="onGridReady"
      @first-data-rendered="onFirstDataRendered"
      @selection-changed="onSelectionChanged"
      @row-clicked="onRowClicked($event)">
    </ag-grid-vue>

    <ModalVerPdf ref="modalVerPdfRef" />

    <ModalArchivoRespaldo
      ref="modalArchivoRespaldoRef"
      respaldoDe="pago-detalle-solicitud"
      @actualizadoArchivoAdjunto="actualizadoArchivoAdjunto" />
  </div>
</template>

<script>
import agGridMixin from '../mixins/ag-grid-mixin';
import { formatearValorAMoneda, OPERACIONES_DETALLE_SOLICITUD } from '../utils';
import PagoDetalleSolicitudService from '../services/pago-detalle-solicitud';
import ModalVerPdf from '../components/ModalVerPdf.vue';
import ModalArchivoRespaldo from './../components/ModalArchivoRespaldo.vue';

export default {
  name: 'ListadoPagoDetalleSolicitud',
  mixins: [agGridMixin],
  components: {
    ModalVerPdf,
    ModalArchivoRespaldo,
  },
  props: {
    rowData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    pinnedBottomRowData() {
      return [
        {
          '#': 'TOTAL',
          monto: this.rowData.reduce((acc, row) => acc + Number(row.monto), 0),
        },
      ];
    },
  },
  data() {
    return {
      recuperandoArchivoAdjunto: false,
      pagoDetalleSeleccionadoId: null,
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return params.data['#'];
            } else {
              return params.node.rowIndex + 1;
            }
          },
          filter: false,
          minWidth: 70,
          maxWidth: 70,
        },
        {
          headerName: 'MONTO',
          field: 'monto',
          filter: false,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value, 2);
          },
          minWidth: 150,
        },
        {
          headerName: 'FECHA',
          field: 'fecha',
          filter: false,
          minWidth: 150,
        },
        {
          headerName: 'NÚMERO DE COMPROBANTE',
          field: 'numero_comprobante',
          filter: false,
          type: 'rightAligned',
          minWidth: 200,
        },
        {
          headerName: 'REGISTRADO POR',
          field: 'registrado_por',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'ADJUNTO',
          cellRenderer: (params) => {
            const archivoId = params.data.archivo_id;

            if (params.node.rowPinned) {
              return undefined;
            } else if (!archivoId) {
              return /*html */ `<span>-</span>`;
            } else if (this.recuperandoArchivoAdjunto && this.pagoDetalleSeleccionadoId === params.data.id) {
              return /*html */ `
                <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear v-progress-linear--visible theme--dark" style="margin-top: 8px; height: 8px;">
                  <div class="v-progress-linear__background primary" style="opacity: 0.3; left: 0%; width: 100%;"></div>
                  <div class="v-progress-linear__buffer"></div>
                  <div class="v-progress-linear__indeterminate v-progress-linear__indeterminate--active">
                    <div class="v-progress-linear__indeterminate long primary"></div>
                    <div class="v-progress-linear__indeterminate short primary"></div>
                  </div>
                </div>`;
            } else {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small blue--text" title="Ver Respaldo Adjunto">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO}">
                      VER ADJUNTO
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-outline"></i>
                  </span>
              </button>
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small success--text" title="Actualizar Respaldo Adjunto">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.ACTUALIZAR_ADJUNTO}">
                      ACTUALIZAR ADJUNTO
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-swap-horizontal"></i>
                  </span>
              </button>`;
            }
          },
          filter: false,
          minWidth: 320,
          maxWidth: 320,
        },
        {
          headerName: 'FECHA REGISTRO',
          field: 'created_at',
          filter: false,
          minWidth: 200,
        },
      ],
    };
  },
  methods: {
    onRowClicked(e) {
      if (e.event.target) {
        let rowIndex = e.node.id;
        let actionType = e.event.target.getAttribute('data-action-type');

        if (actionType) {
          if (actionType == OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO) {
            this.obtenerArchivoAdjunto(this.rowData[rowIndex].id);
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.ACTUALIZAR_ADJUNTO) {
            this.abrirModalArchivo(this.rowData[rowIndex].id, rowIndex);
          }
        }
      }
    },
    async obtenerArchivoAdjunto(pagoDetalleId) {
      this.recuperandoArchivoAdjunto = true;
      this.pagoDetalleSeleccionadoId = pagoDetalleId;
      this.gridApi?.refreshCells();

      try {
        const { data } = await PagoDetalleSolicitudService.obtenerArchivoAdjunto(pagoDetalleId);
        const { datos } = data;

        this.$refs.modalVerPdfRef.abrir(datos);
      } catch (error) {
        window.console.log(error);
        const mensaje = error.response.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al obtener el archivo adjunto',
          type: 'error',
        });
      } finally {
        this.recuperandoArchivoAdjunto = false;
        this.pagoDetalleSeleccionadoId = null;
        this.gridApi?.refreshCells();
      }
    },
    abrirModalArchivo(detalleId, indice) {
      this.$refs.modalArchivoRespaldoRef.abrir(detalleId, indice);
    },
    actualizadoArchivoAdjunto(detalleSeleccionadoIndice, archivoId) {
      this.rowData[detalleSeleccionadoIndice].archivo_id = archivoId;
      this.$refs.modalArchivoRespaldoRef.cerrar();
      this.gridApi?.refreshCells();
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-pagos-detalles-solicitudes {
  height: calc(var(--vh, 1vh) * 100 - 23rem);
}
</style>